(ns practitest.frontend.testset2
  (:require
    [ajax.core :as ajax]
    [clojure.string :as str]
    [practitest.frontend.common-entities :refer [batch-navigate!] :as common-entities]
    [practitest.frontend.common-entities.events :as common-events] ;; Forms version 3 support
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.forms3.entity-form.utils :refer [get-modal-title]]
    [practitest.frontend.components.spinners :as spinners]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.entity-form :as entity-form]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.common.dom :as dom]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [format-translation
                                             get-translation] :as i18n]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch]]
    [practitest.frontend.components.card-view]
    [practitest.frontend.components.confirmation :as confirmation]
    [practitest.frontend.components.tooltip :as tooltip]
    [practitest.frontend.components.grid.events :as grid.events]
    [practitest.frontend.components.grid.localstorage :as grid-storage]
    [practitest.frontend.components.grid.sessionstorage :as grid-session-storage]
    [practitest.frontend.components.grid.subs :as grid.subs]
    [practitest.frontend.components.icons :as icons]
    [practitest.frontend.components.instances2 :as instances]
    [practitest.frontend.components.modal :as modal]
    [practitest.frontend.components.navigation :as navigation]
    [practitest.frontend.components.notifications :as notifications]
    [practitest.frontend.components.overlay2 :as overlay2]
    [practitest.frontend.components.spinners :as spinners]
    [practitest.frontend.components2.buttons :as buttons]
    [practitest.frontend.components2.entity-form :as entity-form]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.grid :as grid2]
    [practitest.frontend.components2.grid.common :as gc]
    [practitest.frontend.components2.grid.row-menu :refer [row-menu]]
    [practitest.frontend.components2.test-type :as test-type]
    [practitest.frontend.events :as events]
    [practitest.frontend.folders :as folders]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.utils :refer [get-modal-title]]
    [practitest.frontend.forms3.testset :as f3.testset]
    [practitest.frontend.forms3.testset.instances :refer [locked-execution-icon]]
    [practitest.frontend.issues.index :refer [admin-permission]]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.routing.router :as router]
    [practitest.frontend.subs :as subs]
    [practitest.frontend.testset2.add-instance2 :as add-instance-view]
    [practitest.frontend.testset2.events :as testset2]
    [practitest.frontend.testset2.select-instance-version-label :as select-version]
    [practitest.frontend.testset2.set-instance-parameters :as set-params]
    [practitest.frontend.testset2.linked-issues-grid :as linked-issues-grid]
    [practitest.frontend.testset2.subs :as testset.subs]
    [practitest.frontend.xbot2.schedule :as schedule]
    [re-frame.core :as re-frame]
    [reagent.core :as reagent]))

(defn run-order-enforcement-icon
  []
  (let [testset @(re-frame/subscribe [::subs/entity :testset])
        enforce-run-order? (get-in testset [:current :enforce_run_order])]
    [:div.run-order-enforcement-container
     [tooltip/mux-tooltip
      {:position "top"}
      (if enforce-run-order?
       (get-translation "testset.instances.enforce-run-order-tooltip" "This Test Set is enforcing run order. You can change this in the Options menu (three dots)")
       (get-translation "testset.instances.dont-enforce-run-order-tooltip" "This Test Set is not enforcing run order. You can change this in the Options menu (three dots)"))
      (fn [props]
        [:div.run-order-icon
         (merge props
                {:class (if enforce-run-order? "enabled" "disabled")})
         [(if enforce-run-order?
            icons/mux-enable-run-order
            icons/mux-disable-run-order)]])]]))

(defn run-order-enforcement-icon-for-grid
  []
  [:div.run-order-enforcement-for-grid
   [run-order-enforcement-icon]])
(def current-entity :testset)
(def metadata (get metadata/entities-metadata current-entity))

(defn instances-toolbar [form-props grid-props]
  (let [local-state-updating (reagent/atom {})
        local-state (reagent/atom {})]
    (fn [{:keys [xbot?
                 edit-permissions?
                 entity-id] :as form-props}
         {:keys [show-edit-columns?] :as grid-props}]
      (let [toggle-add-instances-modal! (fn []
                                          (re-frame/dispatch [::testset2/toggle-add-instances-modal (:per-page-instances-grid-load grid-props)])
                                          (mixpanel/track "Test Set - Add Test Instance"))

            ;; Set of IDs
            selection @(re-frame/subscribe [::grid.subs/selection [:testset :instances-state]])

            ;; TODO: double calculation on every render ? re-frame component ?
            local-grid-rows (grid2/get-local-rows grid-props)
            customized-run? (or (gc/has-any-sorting? local-state-updating)
                                (gc/has-any-filters? local-state-updating))

            current-project @(re-frame/subscribe [::subs/current-project])
            instances @(re-frame/subscribe [::grid.subs/data [:testset :instances-state]])
            versioning-enabled? @(re-frame/subscribe [::subs/test-case-versioning-enabled?])
            versioning-permissions? @(re-frame/subscribe [::subs/versioning-can-use-labels?])]

        [:div.instances-toolbar
         [:div.left-toolbar-section
          [run-order-enforcement-icon-for-grid]]
         (when xbot?
           (let [entity (:current @(re-frame/subscribe [::subs/entity :testset]))
                 run-later (:run_later entity)]
             [schedule/schedule-btn2
              {:run-later run-later
               :entity-id entity-id}]))

         (when (and versioning-enabled? versioning-permissions?)
           [buttons/button
            {:test-id "instances-grid-select-version-label-btn"
             :toolbar? true
             :disabled? (grid.subs/empty-selection? selection)
             :on-click (fn []
                         (re-frame/dispatch [::select-version/show-modal (vec selection)])
                         (mixpanel/track "Grid Actions" {"Action" "Select a Version Label"}))
             :icon [icons/mux-pencil]
             :class "hide-text"
             :tooltip (get-translation "test.versioning.modal.title" "Select a Version label")
             :text (get-translation "test.versioning.modal.title" "Select a Version label")}])

        ;(not (permissions/has-permission? "runs")
         (when (permissions/has-permission? "instances_editor")
           [buttons/button
            {:test-id "instances-grid-add-new-instance-btn"
             :toolbar? true
             :on-click toggle-add-instances-modal!
             :icon [icons/mux-plus-circle]
             :class "hide-text"
             :tooltip (get-translation "testset.instances.add-new-instance" "Add New Instance")
             :text (get-translation "testset.instances.add-new-instance" "Add New Instance")}])

         (when (permissions/has-permission? "instances_editor")
           [buttons/button
            {:test-id "instances-grid-batch-edit-btn"
             :toolbar? true
             :disabled? (grid.subs/empty-selection? selection)
             :on-click (fn [_e]
                         (mixpanel/track "Grid Actions" {"Action" "Batch edit"})
                         (common-events/batch-navigate-guarded
                          {:entity :testset
                           :state-key :instances-state
                           :path (broutes/get-url-view "instances#batch_edit")
                           :selection selection
                           :optional-params {:set_id entity-id}}))
             :icon [icons/mux-pencil]
             :class "hide-text"
             :tooltip (get-translation "testset.button.batch-edit" "Batch Edit")
             :text (get-translation "testset.button.batch-edit" "Batch Edit")}])

         (when (and (:show-fast-run grid-props)
                    (permissions/has-permission? "runs"))
           [buttons/button
            {:test-id "instances-grid-fast-run-btn"
             :toolbar? true
             :disabled? (grid.subs/empty-selection? selection)
             :on-click (let [batch-fast-run-uri (broutes/get-url-view "instances#fast_run")]
                         (fn [_e]
                           (mixpanel/track "Fast run")
                           (batch-navigate! batch-fast-run-uri selection nil {:set_id entity-id})))
             :icon [icons/mux-fast-run]
             :class "hide-text"
             :tooltip (get-translation "testset.button.fast-run" "Fast Run")
             :text (get-translation "testset.button.fast-run" "Fast Run")}])

         (when (permissions/has-permission? "runs")
           [buttons/button
            {:primary? true
             :test-id "instances-grid-run-btn"
             :toolbar? true
             :disabled? (empty? local-grid-rows)
             :on-click (let [run-url (broutes/get-url-view "suites#run_now"
                                                           {:id entity-id})]
                         (fn [_e]
                           (mixpanel/track "Run")
                           (dom/form-navigate! run-url
                                               (when customized-run?
                                                 {"run_order" (str/join "," (map :id local-grid-rows))}))))
             :icon [icons/mux-play]
             :class "hide-text"
             :tooltip (get-translation "testset.button.run" "Run")
             :text (get-translation "testset.button.run" "Run")}])

         ;; More actions
         (let [show? (:show-toolbar-menu? @local-state)
               hide! (fn []
                       (swap! local-state assoc :show-toolbar-menu? false))
               toggle! (fn []
                         (swap! local-state update :show-toolbar-menu? not))

               disabled? (not (permissions/has-permission? "runs"))]
           [overlay2/floating-ui-overlay
            {:placement        "bottom-end"
             :strategy         "absolute"
             :offset           5
             :show?            show?
             :on-request-close hide!}

            ;; Target
            [:button.more-button
             (-> {:class (dom/classes-pairs-v :disabled disabled?)
                  :disabled disabled?
                  :on-click (fn [e]
                              (when-not disabled?
                                (toggle!)))}
                 (dom/add-test-id "instances-grid-more-btn"))
             [icons/mux-three-dots]]

            ;; Menus
            [:div.menu-popup
             {:style {:width     "max-content"
                      :min-width "233px"}}

             ;; Edit columns menu item
             [grid2/edit-columns-menu-item grid-props]

             [navigation/menu-item-element {:text     (get-translation "testset.button.add-new-test" "Add New Test")
                                            :test-id "instances-grid-add-new-test-item"
                                            :on-click (let [add-new-test-uri (broutes/get-url-view "qtest_designs#new"
                                                                                                   {}
                                                                                                   {"add_to_suite" entity-id})]
                                                        (fn [e]
                                                          (dom/prevent-default e)
                                                          (mixpanel/track "Test Set - Create new Test")
                                                          (dom/navigate! add-new-test-uri)))
                                            :icon     icons/mux-plus-circle}]

             (let [disabled? (and (not (permissions/has-permission? "runs_admin")) (grid.subs/empty-selection? selection))
                   n (if (= selection :_all)
                       @(re-frame/subscribe [::testset.subs/testset-instances-total-count])
                       (count selection))
                   show-confirmation? (reagent/cursor local-state [:batch-delete-confirmation?])
                   hide-confirmation! #(reset! show-confirmation? false)
                   show-confirmation! #(reset! show-confirmation? true)]
               [:<>
                (let [;; TODO: reuse confirmation dialog from row-level deletion somehow ?
                      single-instance? (= n 1)
                      row (when single-instance?
                            (first (filter #(= (:id %) (first selection)) instances)))]
                  [confirmation/confirm
                   {:show?     show-confirmation?
                    :title     (if single-instance?
                                 (get-translation "instance.delete-confirmation.title"
                                                  "Delete Instance?")
                                 (get-translation "instance.batch-delete-confirmation.title"
                                                  "Delete Instances?"))
                    :body      (if single-instance?
                                 (let [id (first selection)
                                       row (first (filter #(= (:id %) id) instances))]
                                   (format-translation
                                    (get-translation "instance.delete-confirmation.body"
                                                     "\"%{object-name}\" will be deleted permanently.")
                                    :object-name (fu/truncate-text (:title row) 30)))

                                 ;; Multiple rows deletion
                                 (format-translation
                                  (get-translation "instance.batch-delete-confirmation.body"
                                                   "%{count} instances will be deleted permanently")
                                  :count n))

                    :yes-label "Delete"
                    :on-yes    (fn [e]
                                 (if single-instance?
                                   (re-frame/dispatch [::testset2/delete-instance (:id row)])
                                   (re-frame/dispatch [::testset2/batch-delete-instances selection false entity-id]))

                                 ;; TODO: hide after response ?
                                 (hide-confirmation!))

                    :no-label  "Cancel"
                    :on-no     hide-confirmation!}])

                [navigation/menu-item-element {:text      (get-translation "testset.button.delete" "Delete")
                                               :test-id   "instances-grid-batch-delete-item"
                                               :disabled? (not (permissions/has-permission? "instances_admin"))
                                               :icon      icons/mux-trash
                                               :on-click  (fn [e]
                                                            (dom/prevent-default e)
                                                            (when-not (common-entities/over-batch-limit n)
                                                              (mixpanel/track "Batch delete instances")
                                                              (show-confirmation!)))}]])
             (let [disabled? (or (:no-reorder-permission grid-props)
                                 (= 0 @(re-frame/subscribe [::testset.subs/testset-instances-total-count])))
                   has-sorting? (:has-sorting? grid-props)
                   has-filters? (:has-filters? grid-props)
                   tooltip-text (cond
                                  has-filters? (get-translation "generic.grid.reorder-tooltip.sort-applied"
                                                                "Filters applied. To reorder, please reset the table using the Reset icon")
                                  has-sorting? (get-translation "generic.grid.reorder-tooltip.filters-applied"
                                                                "Sorting applied. To reorder, please reset the table using the Reset icon"))]
               [navigation/menu-item-element (cond-> {:text      (get-translation "testset.button.reorder" "Reorder")
                                                      :test-id   "instances-grid-reorder-item"
                                                      :disabled? (or (not (permissions/has-permission? "instances_editor"))
                                                                     has-sorting?
                                                                     has-filters?)
                                                      :icon      icons/mux-drag-handle
                                                      :on-click  (let [reorder-instances-url (broutes/get-url "suites#sort_instances"
                                                                                                              {:p_id (:id current-project)
                                                                                                               :id   entity-id})]
                                                                   (fn [e]
                                                                     (dom/prevent-default e)
                                                                     (dom/navigate! reorder-instances-url)))}
                                               tooltip-text
                                               (assoc :disabled-tooltip-text tooltip-text
                                                      :disabled-tooltip? true))])
             (let [disabled? (grid.subs/empty-selection? selection)]
               [navigation/menu-item-element {:text      (get-translation "testset.instances.set-parameters" "Set Parameters")
                                              :test-id   "instances-grid-set-parameters-item"
                                              :icon      icons/mux-parameters-set
                                              :disabled? (or disabled? (not (permissions/has-permission? "runs")))
                                              :on-click  (fn [e]
                                                           (dom/prevent-default e)
                                                           (mixpanel/track "Form Actions" {"Action" "Batch_Set_Parameters"})
                                                           (re-frame/dispatch [::set-params/show-modal selection entity-id]))}])

             (let [testset @(re-frame/subscribe [::subs/entity :testset])
                   testset-id (get-in testset [:current :id]) 
                   enforce-run-order? (or (get-in testset [:current :enforce_run_order]) false) 
                   has-enforce-run-order-permission? (or (permissions/has-permission? admin-permission) (permissions/has-permission? "users_n_per"))] 
               [navigation/menu-item-element {:text      (if enforce-run-order?
                                                           (get-translation "testset.instances.dont-enforce-run-order" "Do Not Enforce Run Order")
                                                           (get-translation "testset.instances.enforce-run-order" "Enforce Run Order"))
                                              :test-id   "enforce-run-btn"
                                              :icon      (if enforce-run-order?
                                                           icons/mux-disable-run-order
                                                           icons/mux-enable-run-order)
                                              :disabled? (not has-enforce-run-order-permission?)
                                              :tooltip   (when-not has-enforce-run-order-permission? (get-translation "testset.notify.admin_only" "Only an Administrator can perform this action"))
                                              :on-click  (fn [e]
                                                           (dom/prevent-default e)
                                                           (re-frame/dispatch [::testset2/toggle-enforce-run-order
                                                                               testset-id
                                                                               (not enforce-run-order?)]))}])]])]))))

(defn add-instances-button [{:keys [on-add-instance
                                    adding-instances?
                                    local-state-updating
                                    total-count] :as tableprops}]
  (let [selected-view           (:selected-view-id @local-state-updating)
        selected-tests          (set @(re-frame/subscribe [::testset.subs/selected-tests]))
        selected-tests-count    (if selected-view total-count (count selected-tests))
        has-selected-tests?     (> selected-tests-count 0)
        disabled-state          (or adding-instances?
                                    (not has-selected-tests?))]
    [buttons/button
     {:disabled? disabled-state
      :primary? true
      :toolbar? true
      :on-click (fn [e]
                  (when on-add-instance
                    (on-add-instance selected-tests)))
      :icon (if adding-instances? 
              [spinners/inline-spinner-border]
              [icons/add-plus-icon])
      :text (format-translation
             (get-translation "test.steps.call-to-test.add-selected-tests-count" "Add selected Tests %{count}")
             :count selected-tests-count)
      :size "large"}]
    )
  )


(defn modal-buttons [{:keys [close-instances-dialog] :as grid-props}]
  [:div.add-cancel-component
   [gc/existing-instances-warning-note grid-props]
   [buttons/button
    {:toolbar? true
     :on-click #(close-instances-dialog)
     :size "large"
     :text (get-translation "generic.button.cancel" "Cancel")}]
   [add-instances-button grid-props]
   ])

(defn instances-page
  [form-props]
  (let [
        ;; Required to be able to get the list of instances as displayed on screen
        grid-state (reagent/atom {})

        ;; Container ref for modal (for CSS styles to be applied correctly)
        container-ref (atom nil)]
    (fn [{:keys [new?
                 edit?
                 edit-permissions?
                 expanded?]
          :as   form-props}]
      (let [current-project @(re-frame/subscribe [::subs/current-project])
            testset @(re-frame/subscribe [::subs/entity :testset])
            testset-name (get-in testset [:current :name])
            testset-display-id (get-in testset [:current :display_id])
            testset-id @(re-frame/subscribe [::subs/current-entity-id :testset])
            disabled-action-menu? (not (permissions/has-permission? "runs_admin"))

            pre-columns (when edit?
                          [{:header        "Seq."
                            :field         :position
                            :default-width 70
                            :width         70
                            :type          :number
                            :sortable?     true
                            :systemcol?    true}
                           (when (permissions/has-permission? "runs")
                             {:header        "Run"
                              :field         :run
                              :default-width 60
                              :width         70
                              :type          :custom
                              :text-align    :center
                              :resizable?    false
                              :sortable?     false
                              :systemcol?    true
                              :cell-fn       (fn [column-info row
                                                  {:keys [local-rows
                                                          has-filters?
                                                          has-sorting?]
                                                   :as grid-props}]
                                               (let [run-url (broutes/get-url-view "instances#run_now"
                                                                                   {:set_id testset-id
                                                                                    :id     (:id row)}
                                                                                   {:run_now_origin :instances-grid})
                                                     run-order (when (or has-filters?
                                                                         has-sorting?)
                                                                 (str/join "," (map :id local-rows)))]
                                                 ;; TODO: button component ? Quite peculiar style at a moment
                                                 (if (:execution_locked row)
                                                   [locked-execution-icon]
                                                   [:button.run-button
                                                    {:on-click (fn [e]
                                                                 (mixpanel/track "Run")
                                                                 (if (:able_to_run row)
                                                                   (dom/form-navigate! run-url
                                                                                       (when run-order
                                                                                         {"run_order" run-order}))
                                                                   (notifications/notify! "Can not run this instance - run order is enforced"
                                                                                          {:type       "error"
                                                                                           :auto-close true
                                                                                           :id         "entity-form-notification"})))}
                                                    [icons/mux-run-instance]])))})])
            post-columns (when edit?
                           [{:header        ""
                             :field         :actions
                             :default-width 50
                             :width         50
                             :type          :custom
                             :text-align    :center
                             :resizable?    false
                             :sortable?     false
                             :systemcol?    true
                             :class         ["action-menu"]
                             :cell-fn       (fn [column-info row]
                                              [row-menu row disabled-action-menu?
                                               [{:label    (get-translation "generic.button.edit" "Edit")
                                                 :icon     icons/mux-pencil
                                                 :href     (:url row)
                                                 ;; TODO: fix this
                                                 :on-click (fn [] (mixpanel/track "Grid Actions" {"Action" "Edit Instance"}))}

                                                {:label        (get-translation "generic.button.delete" "Delete")
                                                 :icon         icons/mux-trash
                                                 :disabled?    (not (permissions/has-permission? "instances_admin"))
                                                 :on-click (fn []
                                                             (mixpanel/track "Grid Actions" {"Action" "Delete Instance"})
                                                             (re-frame/dispatch [::testset2/delete-instance (:id row)])
                                                             )
                                                 :confirmation {:title (get-translation "instance.delete-confirmation.title"
                                                                                        "Delete Instance?")
                                                                :body (format-translation
                                                                       (get-translation "instance.delete-confirmation.body"
                                                                                        "\"%{object-name}\" will be deleted permanently.")
                                                                       :object-name (fu/truncate-text (:title row) 30))
                                                                :yes-label (get-translation "generic.button.delete"
                                                                                            "Delete")
                                                                :no-label (get-translation "generic.button.cancel"
                                                                                           "Cancel")}}

                                                {:label     (get-translation "instance.menu.set-parameters" "Set Parameters")
                                                 :icon      icons/mux-parameters-set
                                                 :disabled? (not (permissions/has-permission? "runs"))
                                                 :on-click  (fn []
                                                              (mixpanel/track "Form Actions" {"Action" "Batch_Set_Parameters"})
                                                              (re-frame/dispatch [::set-params/show-modal #{(:id row)} testset-id]))}]])}])

            instances-columns (map
                               (fn [column]
                                 (if (or (= :linked-entities (:type column))
                                         (= :test_type (:type column)))
                                   ;; Override default linked issues behavior to be sortable
                                   (assoc column :sortable? true)
                                   column))
                               @(re-frame/subscribe [::grid.subs/columns [:testset :instances-state]]))
            
            table-id (str (:id current-project) "-testset2-instances-grid")
            table-id-with-testset (str table-id "-" testset-id)
            instance-dialog-table-id (str (:id current-project) "-add-instances-dialog")
            add-selected-tests! (fn [test-ids]
                                  (mixpanel/track "Test Set - Clicked add selected Test")
                                  (re-frame/dispatch [::testset2/add-instances test-ids grid-state]))
            grid-props {:testset-grid?         true
                        :fields                @(re-frame/subscribe [::subs/fields])
                        :columns               instances-columns
                        :pre-columns           pre-columns
                        :post-columns          post-columns

                        :class                 "data-grid-instances"
                        :grid-state            grid-state
                        :show-edit-columns?    true
                        :data                  @(re-frame/subscribe [::grid.subs/data [:testset :instances-state]])

                        ;; Selection props
                        :selected?             #(re-frame/subscribe [::grid.subs/selected? [:testset :instances-state] %])
                        :all-selected?         #(re-frame/subscribe [::grid.subs/all-selected? [:testset :instances-state] %])
                        :selection             @(re-frame/subscribe [::grid.subs/selection [:testset :instances-state]])
                        :clear-selection       (partial-dispatch [::grid.events/clear-selection [:testset :instances-state]])
                        :select-all            (partial-dispatch [::grid.events/select-all [:testset :instances-state]])
                        :toggle-selection      (partial-dispatch [::grid.events/toggle-selection [:testset :instances-state]])
                        :toggle-selection-page (partial-dispatch [::grid.events/toggle-selection-page [:testset :instances-state]])

                        :current-page          @(re-frame/subscribe [::testset.subs/testset-instances-current-page])
                        :total-count           @(re-frame/subscribe [::testset.subs/testset-instances-total-count])
                        :full-data?            @(re-frame/subscribe [::testset.subs/testset-instances-full-data?])
                        :on-query-changed      (partial-dispatch [::testset2/fetch-instances])

                        :per-page-save         (reagent/partial grid-storage/save-per-page table-id)
                        :per-page-load         (reagent/partial grid-storage/load-per-page table-id)
                        :per-page-instances-grid-load (reagent/partial grid-storage/load-per-page instance-dialog-table-id)
                        :current-page-save     (reagent/partial grid-storage/save-current-page table-id-with-testset)
                        :current-page-load     (reagent/partial grid-storage/load-current-page table-id-with-testset)
                        :save-in-url?          true
                        :on-sort-end           (when edit-permissions?
                                                 (partial-dispatch [::sort-instances]))
                        :reorder-in-progress?  @(re-frame/subscribe [::sort-instances-in-progress?])

                        :resizable?            true
                        :columns-widths-save   (reagent/partial grid-storage/save-column-sizes table-id)
                        :columns-widths-load   (reagent/partial grid-storage/load-column-sizes table-id)
                        :columns-settings-save (reagent/partial grid-storage/save-column-settings table-id)
                        :columns-settings-load (reagent/partial grid-storage/load-column-settings table-id)

                        :autofilters-save      (reagent/partial grid-session-storage/save-autofilters table-id-with-testset)
                        :autofilters-load      (reagent/partial grid-session-storage/load-autofilters table-id-with-testset)
                        :sort-order-save       (reagent/partial grid-session-storage/save-sort-order table-id-with-testset)
                        :sort-order-load       (reagent/partial grid-session-storage/load-sort-order table-id-with-testset)

                        :empty-table-message   (get-translation "testset.instances.add-instances-to-your-testset"
                                                                "Add Instances to your test set and start running")
                        ;; For filters
                        :get-field-props       #(re-frame/subscribe [::subs/field-props :instance %])
                        :no-reorder-permission  (and (:enforce_run_order current-project)
                                                     (not (permissions/project-administrator? current-project)))
                        :show-fast-run         (:show_fast_run current-project)
                        :grid-toolbar          (fn [grid-props]
                                                 ;; partial doesn't work here (most likely because instances-toolbar is form-2 component
                                                 [instances-toolbar form-props grid-props])

                        :on-expand-click       (partial-dispatch [::common-events/toggle-expanded :testset :instances-state])
                        :expanded?             expanded?
                        :loading?              @(re-frame/subscribe [::subs/progress? ::testset2/fetch-instances])
                        :local-state-updating  (or grid-state
                                                   (reagent/atom {}))
                        :close-instances-dialog       (partial-dispatch [::testset2/hide-add-instances-modal])
                        :on-add-instance       (fn [test-ids]
                                                 (add-selected-tests! test-ids))}

            show-add-instances-modal? (re-frame/subscribe [::testset.subs/show-add-instances?])
            hide-add-instances-modal! #(re-frame/dispatch [::testset2/hide-add-instances-modal])]
        [:div.instances-container.entities-grid
         {:ref #(reset! container-ref %)}

         (when-not expanded?
           ;; Dashboard container
           [instances/instances-dashboard])

         ;; Add instances dialog
         [modal/bootstrap-modal
          {:is-open?         @show-add-instances-modal?
           :on-request-close hide-add-instances-modal!
           :container-ref    container-ref
           :class            "add-instances-modal"
           :close-button?    true}

          [:span {:style {:font-weight 600}}
           (get-modal-title
            (get-translation "testset.title.adding-test-instances" "Add Test Instances")
            (get-translation "to.testset" "to Testset")
            testset-display-id
            testset-name)]

          [add-instance-view/add-tests-component nil]
          [modal-buttons grid-props]]

         [select-version/select-instance-label-modal]

         ;; Skip message modal for partial version label updates
         [select-version/skip-message-modal]

         [set-params/set-instance-parameters-modal]

         [:div.grid-with-run-order-icon
          [grid2/grid grid-props]
          [:div.run-order-icon-container
           ]]]))))

(defn linked-issues-page
  [_form-props]
  (let [project-id @(re-frame/subscribe [::subs/current-project-id])
        testset-id @(re-frame/subscribe [::subs/current-entity-id :testset])
        table-id (str project-id "-testset-linked-issues")
        table-id-with-testset (str table-id "-" testset-id)]
    (reagent/create-class
     {:component-did-mount
      (fn [] (re-frame/dispatch [::testset2/fetch-linked-issues]))
      :reagent-render
      (fn [_form-props]
        (let [fields @(re-frame/subscribe [::subs/fields])
              expanded? @(re-frame/subscribe [::grid.subs/expanded? :testset :linked-issues-state])
              priority-col (when-let [f (get fields :priority)]
                             (assoc (grid.subs/field->column nil f)
                                    :systemcol?    true
                                    :default-show? true
                                    :default-width 100))
              columns (linked-issues-grid/get-linked-issues-columns priority-col @(re-frame/subscribe [::subs/users]))]
          [grid2/grid
           {:columns           columns
            :data              @(re-frame/subscribe [::testset.subs/linked-issues-data])
            :total-count       @(re-frame/subscribe [::testset.subs/linked-issues-total-count])
            :current-page      @(re-frame/subscribe [::testset.subs/linked-issues-current-page])
            :full-data?        @(re-frame/subscribe [::testset.subs/linked-issues-full-data?])
            :on-query-changed  (partial-dispatch [::testset2/fetch-linked-issues])
            :resizable?          true
            :columns-widths-save (reagent/partial grid-storage/save-column-sizes table-id)
            :columns-widths-load (reagent/partial grid-storage/load-column-sizes table-id)
            :per-page-save     (reagent/partial grid-storage/save-per-page table-id)
            :per-page-load     (reagent/partial grid-storage/load-per-page table-id)
            :current-page-save (reagent/partial grid-storage/save-current-page table-id-with-testset)
            :current-page-load (reagent/partial grid-storage/load-current-page table-id-with-testset)
            :get-field-props   #(re-frame/subscribe [::subs/field-props :issue %])
            :show-edit-columns? false
            :autofilters-save  (reagent/partial grid-session-storage/save-autofilters table-id)
            :autofilters-load  (reagent/partial grid-session-storage/load-autofilters table-id)
            :sort-order-save   (reagent/partial grid-session-storage/save-sort-order table-id)
            :sort-order-load   (fn [] (or (grid-session-storage/load-sort-order table-id) [:display_id :desc]))
            :on-expand-click   (partial-dispatch [::common-events/toggle-expanded :testset :linked-issues-state])
            :expanded?         expanded?
            :loading?          @(re-frame/subscribe [::subs/progress? ::testset2/fetch-linked-issues])}]))})))

(re-frame/reg-event-fx
  ::sort-instances
  (fn [{:keys [db]} [_ newitems]]
    (let [payload (map #(select-keys % [:id :name]) newitems)
          uri (broutes/get-url "instances#sort"
                               {:p_id   (get-in db [:current-project :id])
                                :set_id (get-in db [:entity :testset :current :id])})]
      {:db (update db :progress conj ::sort-instances)
       :http-xhrio
       {:method          :post
        :uri             uri
        :params          payload
        :format          (ajax/json-request-format)
        :response-format (ajax/raw-response-format)
        :on-success      [::sort-instances-success]
        :on-failure      [::sort-instances-failure]}})))

(re-frame/reg-sub
  ::sort-instances-in-progress?
  (fn [db]
    (contains? (:progress db) ::sort-instances)))

(re-frame/reg-event-fx
  ::sort-instances-success
  (fn [{:keys [db]} _]
    {
     ;; Progress will be disj'ed in fetch-instances handler
     ;; TODO: do not refetch, get data straight from backend
     :fx [[:dispatch [::testset2/fetch-instances]]]}))

(re-frame/reg-event-fx
  ::sort-instances-failure
  (fn [{:keys [db]} _]
    {:db (update db :progress disj ::sort-instances)
     :fx [[:dispatch [::notifications/error2
                      (get-translation "testset.notification.instances-reorder-error" "Error reordering instances")
                      {:id "instances-error-message"}]]]}))

(re-frame/reg-event-db
  ::reset-testset-state
  (fn [db _]
    (update-in db [:entity :testset] dissoc :instances-state)))

(defn build-new-controller
  []
  {:start    (fn [params]
               (let [project-id (get-in params [:path :project-id])]
                 (re-frame/dispatch [::events/set-current-entity-type :testset])
                 ;; TODO: fix this in future - right now when you create testset from requirements
                 ;; it passes requirement ids on URL, but behind the scenes it fills actual tests ids in initialize-db
                 ;; call, which obviously wouldn't work in SPA scenario. For now we're back to using init-db call for this
                 #_(when-let [ids (get-in parameters [:query :ids])]
                     (re-frame/dispatch [::testset2/set-instances-to-add ids]))

                 ;; Folders are only needed in testsets and tests
                 (re-frame/dispatch [::folders/fetch-folders :testset true])

                 (re-frame/dispatch [::f3.entity-form/fetch-fields {:form-id :testset
                                                                    :entity-type :testset
                                                                    :project-id project-id
                                                                    :new? true}])))
   :stop (fn [params]
           (re-frame/dispatch [::forms/reset-form-state false :testset :testset []]))
   :identity :parameters})

(defn build-edit-controller
  []
  {:start (fn [params]
            (let [entity-id (get-in params [:path :testset-id])
                  project-id (get-in params [:path :project-id])]

              (let [fetch-options {:form-id     :testset
                                   :entity-type :testset
                                   :entity-id   entity-id
                                   :project-id  project-id
                                   :new?        false}]
                (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options]))

              (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]])

              (re-frame/dispatch [::events/set-current-entity-type :testset])
              (re-frame/dispatch [::subs/set-current-entity-id
                                  :testset
                                  entity-id])

              ;; TODO: move to new entity form data fetching namespace
              (re-frame/dispatch [::events/fetch-comments])
              (re-frame/dispatch [::events/fetch-attachments])
              (re-frame/dispatch [::events/fetch-history])
              (mixpanel/track "Grid Actions" {"Action" "Edit TestSet"})
              (re-frame/dispatch [::testset2/fetch-instances])
              (re-frame/dispatch [::testset2/fetch-graphs])

              ;; Folders are only needed in testsets and tests
              (re-frame/dispatch [::folders/fetch-folders :testset true])

              ;; Restore add instances modal from fragment (if required)
              (re-frame/dispatch [::testset2/restore-add-instances-modal])
              (re-frame/dispatch [::common-events/trigger-online-request])
              (re-frame/dispatch [::common-events/reset-expanded :testset (:testset subs/index-grid-keys)])))

   :stop  (fn [_params]
            ;; params here are params of OLD match
            ;; you can get new route using (router/get-current-route) (it's already updated at this time)
            ;(js/console.log "stop edit-controller" params)

            (re-frame/dispatch [::events/clear-current-entity :testset])
            (let [route-name (get-in (router/get-current-route) [:data :name])]
              ;; We want to preserve testset state so instance navigation with Prev / Next works correctly
              (when-not (contains? #{:practitest.frontend.forms3.instance/edit
                                     :practitest.frontend.forms3.instance/edit2}
                                   route-name)
                (re-frame/dispatch [::reset-testset-state])))
            (re-frame/dispatch [::forms/reset-form-state false :testset :testset []])
            (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
            (re-frame/dispatch [::common-events/reset-expanded :testset [:instances-state :history2 :linked-issues-state]]))

   :identity :parameters})

(defn main [new?]
  [f3.testset/main instances-page linked-issues-page new?])

(re-frame/reg-event-db
  ::update-options
  (fn [db [_ additional-options]]
    (-> db
        (update :options merge additional-options))))

(defn ^:export init [options]
  (let [{:keys [config translation]} (-> options
                                         (js->clj :keywordize-keys true))
        additional-options (select-keys config [:created_from
                                                :entity-id
                                                :new_form_starting_with_test_ids])
        entity-id (:entity-id additional-options)
        new-entity? (or (nil? entity-id)
                        (str/blank? entity-id))]
    ;; Generally it's not a good idea to call subscriptions outside of reactive context
    ;; newer versions of re-frame (since 1.3.0-rc3) have explicit warning about this
    ;; But here we're calling it once, so we don't really risk memory leaks or anything
    ;; Still would be a good idea to change this in future
    (i18n/append-translation! @(re-frame/subscribe [::subs/current-locale]) translation)
    (re-frame/dispatch-sync [::update-options additional-options])

    ;; TODO: cleanup this, see notes in practitest.frontend.testset2/new-controller
    (when new-entity?
      (re-frame/dispatch [::testset2/set-instances-to-add (:new_form_starting_with_test_ids config)]))
    ;; TODO: is this actually used anywhere ? Cleanup if not
    (when new-entity?
      (re-frame/dispatch [::testset2/set-suite-created-from (:created_from config)]))

    (mixpanel/track (if new-entity? "New Entity" "Edit Entity")
                    {"Entity" "Test Set"})))
